/* eslint-disable no-shadow */
import { STRINGS } from 'config';

export const initialState = {
  treatmentCategories: [],
  error: '',
};

export const treatmentCategoriesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_REQUEST:
      return { ...state, error: initialState.error };
    case STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_SUCCESS:
      return { ...state, treatmentCategories: action.payload };
    case STRINGS.TREATMENT_CATEGORIES_REDUCER.GET_TREATMENT_CATEGORIES_ERROR:
      return { ...state, error: action.payload };
    case STRINGS.CONSULTATION_REDUCER.SET_DISCLAIMER_QUESTION:
      return { ...initialState };
    case STRINGS.SESSION_REDUCER.RESTART_SESSION:
      return { ...initialState };
    default:
      return state;
  }
};
